import BreadCrumb from "Components/Common/BreadCrumb";
import "react-toastify/dist/ReactToastify.css";
import { Card, Container, Input } from "reactstrap";
import "./promotion.scss";
import radga from "../../assets/images/radga.png";
import teb from "../../assets/images/Cell Tab@2x.png";
import cell from "../../assets/images/cop.png";
import { useEffect, useState } from "react";
import DeactiveModal from "./Components/DeactiveModal";
import ApplyProductModal from "./Components/ApplyProductMOdal";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getProducts as onGetProducts } from "../../live-slices/products/thunk";
import { createSelector } from "reselect";
import {
  createVoucherConfig,
  editVoucherConfig,
  fetchVoucherDetail,
  uploadFileCsv,
} from "live-slices/voucher/thunk";
import ErrorModal from "Components/Common/ErrorModal";

const ManageProduct = (props: any) => {
  const [deActiveModal, setdeActiveModal] = useState(false);
  const [applyProductModal, setApplyProductModal] = useState(false);
  const [products, setProducts] = useState();
  const [selectedProducts, setSelectedProducts] = useState([]);
  const location = useLocation();
  const formValues = location.state;
  const [searchTerm, setSearchTerm] = useState("");
  const dispatch: any = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();
  const [checkedProducts, setCheckedProducts] = useState<number[]>([]);
  const [errorMessage, setErrorMessage] = useState<string>("");
  const [showModal, setShowModal] = useState({
    isVisible: false,
    color: false,
  });

  const selecteProductData = createSelector(
    (state: any) => state.Product,
    (Ecommerce) => Ecommerce?.data
  );

  const productData = useSelector(selecteProductData);

  const selectUploadProductData = createSelector(
    (state: any) => state.vouchers,
    (productUpload) => productUpload?.productUpload
  );
  const uploadedProduct = useSelector(selectUploadProductData);

  const selectVoucherData = createSelector(
    (state: any) => state.vouchers,
    (voucherData) => voucherData?.voucherData
  );

  const editData = useSelector(selectVoucherData);

  const handleApply = async () => {
    try {
      const payload = {
        collectStartTime:
          new Date(formValues.collectStartTime).getTime() ||
          editData?.collectStartTime,
        redeemStartPeriod:
          new Date(formValues.redeemStartPeriod).getTime() ||
          editData?.redeemStartPeriod,
        redeemEndPeriod:
          new Date(formValues.redeemEndPeriod).getTime() ||
          editData?.redeemEndPeriod,
        minSpendAmount:
          Number(formValues.minSpendAmount) || editData?.minSpendAmount,
        maxDiscountPerOrder:
          Number(formValues.maxDiscountPerOrder) ||
          editData?.maxDiscountPerOrder,
        flatAmount: Number(formValues.flatAmount) || editData?.flatAmount,
        discountAmount:
          Number(formValues.discountAmount) || editData?.discountAmount,
        limitOfVouchers:
          Number(formValues.limitOfVouchers) || editData?.limitOfVouchers,
        limitPerUser: Number(formValues.limitPerUser) || editData?.limitPerUser,
        promotionName: formValues.promotionName || editData?.promotionName,
        discountType: formValues.discountType || editData?.discountType,
        isEntireShop: false,
        _id: editData ? editData._id : null,
        productIds: selectedProducts.map((product: any) => product.productId),
      };
      let response;
      if (formValues._id || (editData && editData._id)) {
        response = await dispatch(editVoucherConfig(payload));
        if (response?.payload?.isSuccess) {
          setErrorMessage("Voucher updated successfully!");
          setShowModal({ isVisible: true, color: true });
          setTimeout(() => {
            setShowModal({ isVisible: false, color: true });
          }, 1000);
        } else {
          setErrorMessage("Failed to update voucher.");
          setShowModal({ isVisible: true, color: false });
          setTimeout(() => {
            setShowModal({ isVisible: false, color: false });
          }, 1000);
          return;
        }
      } else {
        response = await dispatch(createVoucherConfig(payload));
        if (response?.payload?.isSuccess) {
          setErrorMessage("Voucher created successfully!");
          setShowModal({ isVisible: true, color: true });
          setTimeout(() => {
            setShowModal({ isVisible: false, color: true });
          }, 1000);
        } else {
          setErrorMessage("Failed to create voucher.");
          setShowModal({ isVisible: true, color: false });
          setTimeout(() => {
            setShowModal({ isVisible: false, color: false });
          }, 1000);
          return;
        }
      }

      navigate("/promotion");
    } catch (error) {
      console.error("Error applying voucher:", error);
      setErrorMessage("Something went wrong while processing the voucher.");
      setShowModal({ isVisible: true, color: false });
      setTimeout(() => {
        setShowModal({ isVisible: false, color: false });
      }, 1000);
    }
  };

  const fetchProductData = async () => {
    try {
      const res = await dispatch(
        onGetProducts({
          page: 1,
          count: 10,
          status: "active",
          keyword: searchTerm,
        })
      );

      setProducts(res?.payload?.data);
    } catch (error) {
      console.error("Error fetching products:", error);
    }
  };

  useEffect(() => {
    if (uploadedProduct) {
      setSelectedProducts(uploadedProduct);
    }
  }, [uploadedProduct]);

  useEffect(() => {
    if (id) {
      dispatch(fetchVoucherDetail(id)).then((data: any) => {
        if (data.type == "Voucher/fetchVoucherDetail/fulfilled") {
          setSelectedProducts(data.payload.products);
        }
      });
    }
    if (formValues) {
      console.log(formValues);
      fetchProductData();
      setSelectedProducts(formValues.products);
    }
  }, [searchTerm]);

  const handleDeleteSelected = () => {
    const updatedProducts = selectedProducts.filter(
      (product: any) => !checkedProducts.includes(product.id)
    );
    setSelectedProducts(updatedProducts);
    setCheckedProducts([]);
  };
  const handleSelectAll = (e: React.ChangeEvent<HTMLInputElement>) => {
    const isChecked = e.target.checked;
    if (isChecked) {
      const allIds = selectedProducts.map((product: any) => product.id);
      setCheckedProducts(allIds);
    } else {
      setCheckedProducts([]);
    }
  };

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      const formData = new FormData();
      formData.append("file", file); // key should match backend
      dispatch(uploadFileCsv(formData));
    }
  };

  return (
    <div className="page-content Promotion-Main">
      <DeactiveModal
        show={deActiveModal}
        onCloseClick={() => setdeActiveModal(false)}
      />
      <ErrorModal
        show={showModal.isVisible}
        message={errorMessage}
        color={showModal.color}
        onCloseClick={() => setShowModal({ isVisible: false, color: false })}
      />
      <ApplyProductModal
        show={applyProductModal}
        onSearch={setSearchTerm}
        onCloseClick={() => setApplyProductModal(false)}
        productData={products}
        onSelectProducts={(selected) => setSelectedProducts(selected)}
        preSelectedProducts={editData?.products || []}
        searchTerm={searchTerm}
      />

      <Container fluid>
        <BreadCrumb
          title="Regular Voucher"
          pageTitle="Promotion"
          pageTitleRoute="/promotion"
        />
        <Card className="ManageProductCard-Main">
          <div className="mainbasic">
            <div className="basictoow">
              <div className="background">
                <div>
                  <p>
                    Buypass <br /> Vouchers
                  </p>
                  <h6>Rs.{formValues?.flatAmount || editData?.flatAmount}</h6>
                  <h5>
                    Min.Spend <br /> Rs{" "}
                    {formValues?.minSpendAmount || editData?.minSpendAmount}
                  </h5>
                </div>

                <div className="dotdot"></div>

                <div className="tooww">
                  <button>
                    Use Now <img src={radga} alt="" />{" "}
                  </button>
                  <p>Valid until Feb 28, 2025</p>
                </div>
              </div>
            </div>
            <div className="basicinformation">
              <div>
                <p>Basic Information</p>
              </div>
              <div className="vouher">
                <div className="limit">
                  <p>
                    Voucher Type: <span> Regular Voucher </span>
                  </p>
                  <p>
                    Voucher Limit Per Customer:{" "}
                    <span>
                      {" "}
                      {formValues.limitPerUser || editData?.limitPerUser}
                    </span>
                  </p>
                </div>
                <div className="limit">
                  <p>
                    Voucher Limit Per Customer:{" "}
                    <span>
                      {formValues.limitPerUser || editData?.limitPerUser}{" "}
                    </span>
                  </p>
                  <p>
                    Discount:{" "}
                    <span>
                      {" "}
                      If order value reaches: Rs{" "}
                      {formValues.minSpendAmount || editData?.minSpendAmount},
                      Discount would be{" "}
                      {formValues.discountAmount ||
                        editData?.discountAmount + "%"}{" "}
                      off{" "}
                    </span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </Card>
        <Card className="ManageProductCard-Main">
          <div className="mainexel">
            <div className="threebut">
              <h1>Add Products</h1>
              <div className="therrmai">
                <button
                  data-testing-id="ApplyProduct"
                  className="elect"
                  onClick={() => setApplyProductModal(true)}
                >
                  Select Products ({selectedProducts?.length})
                </button>
                <input
                  type="file"
                  accept=".csv, .xls, .xlsx"
                  id="csvUploadInput"
                  style={{ display: "none" }}
                  onChange={handleFileChange}
                />
                <button
                  data-testing-id="ExcelBY"
                  className="xeel"
                  onClick={() =>
                    document.getElementById("csvUploadInput")?.click()
                  }
                >
                  {" "}
                  <img
                    src={cell}
                    alt=""
                    style={{ width: "16px", marginRight: "5px" }}
                  />
                  Upload By Excel
                </button>

                <button
                  className="elete"
                  onClick={handleDeleteSelected}
                  data-testing-id="DeleteBY"
                >
                  <img
                    src={teb}
                    alt=""
                    style={{
                      width: "16px",
                      marginRight: "5px",
                      color: "rgb(181, 181, 182)",
                    }}
                  />
                  Delete
                </button>
              </div>
            </div>
            <div className="AddProductListing_Main">
              <table className="w-100">
                <thead>
                  <tr>
                    <th>
                      <div className="d-flex gap-2">
                        <input
                          type="checkbox"
                          className="sellerCheckbox m-0 form-check-input"
                          onChange={handleSelectAll}
                          data-testing-id="selectAllInput_BlockedKeyword"
                          // handle "Select All" logic if needed
                        />
                        <p>Product Info</p>
                      </div>
                    </th>
                    <th>Retail Price</th>
                    <th>
                      <p>Sale Price</p>
                    </th>
                    <th>
                      <p>Stock</p>
                    </th>
                    <th>
                      <p>Status</p>
                    </th>
                    <th>
                      <p>Action</p>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {selectedProducts && selectedProducts.length > 0 ? (
                    selectedProducts.map((product: any, index) => (
                      <tr key={index}>
                        <td
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "10px",
                          }}
                        >
                          <input
                            type="checkbox"
                            data-testing-id="sellerCheckbox"
                            className="sellerCheckbox m-0 form-check-input"
                            checked={checkedProducts.includes(product.id)}
                            onChange={(e) => {
                              const isChecked = e.target.checked;
                              setCheckedProducts((prev) =>
                                isChecked
                                  ? [...prev, product.id]
                                  : prev.filter((id) => id !== product.id)
                              );
                            }}
                          />
                          <p>{product.nameEn}</p>
                        </td>
                        <td>
                          <p className="text-secondary fw-bold">
                            {product.price || "-"}
                          </p>
                        </td>
                        <td>
                          <p>{product.price || "-"}</p>
                        </td>
                        <td>
                          <p>{product.stock || "-"}</p>
                        </td>
                        <td>
                          <p>{product.status || "-"}</p>
                        </td>
                        <td>
                          <p>{product.subProduct4 || "-"}</p>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={6} className="text-center p-2">
                        No Selected Product
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
            <div className="butlisting">
              <button onClick={handleApply}>Apply</button>
            </div>
          </div>
        </Card>
      </Container>
    </div>
  );
};

export default ManageProduct;
